export const CustomerAddressLabels = {
  FIRSTNAME: 'First Name*',
  LASTNAME: 'Last Name*',
  COMPANY: 'Company',
  LINE_1: 'Address line 1*',
  LINE_2: ' Address line 2',
  CITY: 'City*',
  STATE: 'State*',
  COUNTY: 'State / County',
  ZIP: 'Zip / Postcode*',
  COUNTRY: 'Country*',
  PHONE: 'Phone*',
  UPDATE_SHIPPING_BUTTON: 'UPDATE SHIPPING ADDRESS',
  UPDATE_BILLING_BUTTON: 'UPDATE BILLING ADDRESS',
};
